import { render, staticRenderFns } from "./InstructionViewPublisher.vue?vue&type=template&id=3e4d70c7&scoped=true"
import script from "./InstructionViewPublisher.vue?vue&type=script&lang=js"
export * from "./InstructionViewPublisher.vue?vue&type=script&lang=js"
import style0 from "./InstructionViewPublisher.vue?vue&type=style&index=0&id=3e4d70c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4d70c7",
  null
  
)

export default component.exports